// Dependencies
import React from 'react'
import _ from 'lodash'
import styled, { css, ThemeProvider } from 'styled-components'
import { Types, Components } from '../../types'
import { useDebug } from '../../hooks'
import DesktopMenuProvider, { DesktopMenuContext } from '../../contexts/VerticalDesktopMenu'
import Navigation from './Navigation'
import Megamenu from './VerticalMenu/Megamenu'
import Portal from '../Portal'

const DesktopMenuVertical = (props: Components.DesktopMenu) => {
  useDebug('Components/DesktopMenu')

  return (
    <DesktopMenuProvider {...props}>
      <DesktopMenuWrapper />
      {/* <DesktopMenuOverlay /> */}
    </DesktopMenuProvider>
  );
}

const DesktopMenuWrapper = () => {

  const { active, config, theme, handleSelect, handleReset }: any = React.useContext(DesktopMenuContext);

  return (
    <ThemeProvider theme={theme.dark}>
      <StyledContainer onMouseLeave={handleReset} onMouseEnter={() => active && handleReset.cancel()}>
        <Navigation />
        <Megamenu />
      </StyledContainer>
    </ThemeProvider>
  )

}

const DesktopMenuOverlay = () => {

  const { active, config, theme, handleSelect, handleReset } = React.useContext(DesktopMenuContext);

  if ( ! active ) {
    return null;
  }

  return (
    <Portal>
      <StyledOverlay />
    </Portal>
  )

}

const StyledOverlay = styled.div<any>(({ config, theme }) => css`
    z-index: -1;
    position: fixed;
    top: var(--wooptima-navigation-offset-y);
    left: 0;
    width: 100vw;
    height: calc(100vh - var(--wooptima-navigation-offset-y));
    flex: 1;
    background: #6f70893f;
    opacity: 1;
/* 
    &.overlay-enter {
        opacity: 0;
    }

    &.overlay-enter-active {
        opacity: 1;
        transition: all 300ms ease-in-out;
    }
    
    &.overlay-exit-active {
        opacity: 0;
        transition: all 300ms ease-in-out;
    } */
`);

const StyledContainer = styled.nav<any>(({ config, theme }) => css`
  width: 100%;
  display: flex;
  position: relative;
  z-index: 9999;
  flex-direction: column;
	filter: drop-shadow(0 0 1em rgba(0,0,0,.1));
	-webkit-filter: drop-shadow(0 0 1em rgba(0,0,0,.1));
	-moz-filter: drop-shadow(0 0 1em rgba(0,0,0,.1));
`)


export default DesktopMenuVertical;
